import { useState, useEffect } from "react";
import "../src/assets/components/listalluser.css";
import "../src/assets/components/global.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AutoLogout from "./autologout";
import { useAuth } from "./authprovider"; // Import the useAuth hook
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";

function Memberpage() {
  const { brgyId } = useParams();
  const navigate = useNavigate();
  const [newmeeting, setNewmeeting] = useState("0");
  const [isHamburgerClicked, setIsHamburgerClicked] = useState(false);
  const { logout } = useAuth(); // Destructure the logout function from useAuth

  const handleHamburgerClick = () => {
    setIsHamburgerClicked(!isHamburgerClicked);
  };

  useEffect(() => {
    axios
      .get("https://brgytracerappserver.onrender.com/adminpage")
      .then((response) => {
        setNewmeeting(response.data.newmeeting);
        // setLoading(false);
      })
      .catch((error) => {
        // setError(error);
        // setLoading(false);
      });
  }, []);
  const myinfo = () => {
    navigate(`/myinfo/${brgyId}`);
  };
  const meetings = () => {
    // navigate("/memberviewmeeting");
    navigate(`/memberviewmeeting/${brgyId}`);
  };
  const handleLogout = () => {
    logout(); // Call the logout function from useAuth to clear user data
  };

  return (
    <div className="member-parent dashboard-height">
      <AutoLogout />
      <div className="member-holder">
        <div
          id="hamburger"
          className={`header-area ${isHamburgerClicked ? "is-clicked" : ""}`}
          onClick={handleHamburgerClick}>
          <div className="hidden-menuBar">
            <div className="navigation"></div>
            <ul>
              <img src={logo} alt="" title="" width="100px" height="100px" />
              <li onClick={myinfo}>MyInformation</li>
              <li onClick={meetings}>
                Meeting <label>{newmeeting}</label>
              </li>
              <li>Chat</li>
              <li onClick={handleLogout}>Logout</li>
            </ul>
            <div className="brgID">
              <p>
                BrgyId:<label>{brgyId}</label>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Memberpage;
